/* Open the AfterSell cart drawer after an add. Waits briefly for AfterSell to load; if it never does, falls back to the cart page (never straight to checkout). */
window.ttpOpenCart = window.ttpOpenCart || function (btns) {
  var restore = function () {
    (btns || []).forEach(function (b) { b.disabled = false; var o = b.getAttribute('data-orig'); if (o) b.innerHTML = o; });
  };
  var tries = 0;
  (function attempt() {
    var a = window.aftersell && window.aftersell.cart && window.aftersell.cart.actions;
    if (a && typeof a.open === 'function') {
      Promise.resolve(typeof a.refresh === 'function' ? a.refresh() : null)
        .catch(function () {})
        .then(function () { a.open(); restore(); });
    } else if (tries++ < 20) {
      setTimeout(attempt, 150);
    } else {
      window.location.href = '/cart';
    }
  })();
};

/* TTP 16oz Lotion Lander — selection state, pack/plan rendering, sticky bar, add to cart. No dependencies. */
(function () {
  'use strict';

  var root = document.querySelector('[data-ll-root]');
  if (!root) return;

  var data;
  try { data = JSON.parse(root.querySelector('[data-ll-data]').textContent); } catch (e) { return; }
  var lotions = data.lotions || [];
  if (!lotions.length) return;

  var cfg = root.dataset;
  var showSingle = cfg.showSingle === 'true';
  var drawerMode = cfg.afterAdd === 'drawer';
  var ORDER = ['a', 'b'];
  var $ = function (sel, ctx) { return (ctx || root).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || root).querySelectorAll(sel)); };

  var el = {
    img: $('[data-ll-img]'),
    packs: $('[data-ll-packs]'),
    single: $('[data-ll-single]'),
    pitchName: $('[data-ll-pitch-name]'),
    pitchText: $('[data-ll-pitch-text]'),
    rating: $('[data-ll-rating]'),
    stars: $('[data-ll-stars]'),
    ratingNum: $('[data-ll-rating-num]'),
    ratingCount: $('[data-ll-rating-count]'),
    onceInput: $('[data-ll-type][value="once"]'),
    subInput: $('[data-ll-type][value="sub"]'),
    oncePrice: $('[data-ll-once-price]'),
    subPrice: $('[data-ll-sub-price]'),
    subPct: $('[data-ll-sub-pct]'),
    subPanel: $('[data-ll-subpanel]'),
    subNote: $('[data-ll-subnote]'),
    plan: $('[data-ll-plan]'),
    terms: $('[data-ll-terms]'),
    live: $('[data-ll-live]'),
    finalSel: $('[data-ll-final-sel]'),
    sticky: $('[data-ll-sticky]'),
    sName: $('[data-ll-s-name]'),
    sDetail: $('[data-ll-s-detail]'),
    mainCta: $('[data-ll-cta-main]'),
    final: $('[data-ll-final]')
  };
  var buyBtns = $$('[data-ll-buy]');
  var chipInputs = $$('[data-ll-lotion]');
  var typeInputs = $$('[data-ll-type]');
  var errBoxes = $$('[data-ll-error]');

  var state = { li: 0, pack: cfg.defaultPack === 'b' ? 'b' : 'a', type: 'once', planLabel: null, planId: null, busy: false };
  var d0 = parseInt(cfg.defaultLotion, 10);
  state.li = d0 > 0 && d0 <= lotions.length ? d0 - 1 : 0;
  var checkedChip = chipInputs.filter(function (i) { return i.checked; })[0];
  if (checkedChip) state.li = parseInt(checkedChip.value, 10) || 0;

  function h(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }
  function cur() { return lotions[state.li]; }
  function pk(l, k) { return (l.packs || {})[k]; }
  function packKeys(l) { return (showSingle ? ORDER.concat(['s']) : ORDER).filter(function (k) { return pk(l, k); }); }
  function isAvail(l, k) { var p = pk(l, k); return !!(p && p.avail); }
  function lotionAvail(l) { return isAvail(l, 'a') || isAvail(l, 'b') || (showSingle && isAvail(l, 's')); }
  function plansFor(p) {
    return ((p && p.plans) || []).slice().sort(function (x, y) { return y.pct - x.pct; });
  }

  /* Keep the pack valid for the current lotion; fall back to an available one. */
  function ensurePack() {
    var l = cur();
    if (packKeys(l).indexOf(state.pack) > -1 && isAvail(l, state.pack)) return true;
    var alt = packKeys(l).filter(function (k) { return isAvail(l, k); })[0];
    if (!alt) return false;
    state.pack = alt;
    return true;
  }

  /* ── Rendering ─────────────────────────────────────── */
  function renderLotion() {
    var l = cur();
    if (el.img && l.img) {
      el.img.src = l.img.src;
      el.img.srcset = l.img.srcset;
      el.img.alt = l.img.alt;
    }
    el.pitchName.textContent = l.pitch + ': ' + l.name;
    el.pitchText.textContent = l.text;
    if (el.rating) {
      if (l.count > 0) {
        el.rating.hidden = false;
        el.stars.style.setProperty('--r', l.rating);
        el.stars.setAttribute('aria-label', l.rating + ' out of 5 stars');
        el.ratingNum.textContent = (Math.round(l.rating * 10) / 10).toFixed(1);
        el.ratingCount.textContent = l.count;
      } else {
        el.rating.hidden = true;
      }
    }
    chipInputs.forEach(function (i) {
      var lt = lotions[parseInt(i.value, 10)];
      i.checked = parseInt(i.value, 10) === state.li;
      i.disabled = !lotionAvail(lt);
    });
    renderPacks();
  }

  function renderPacks() {
    var l = cur();
    ensurePack();
    el.packs.textContent = '';
    packKeys(l).forEach(function (k) {
      var p = pk(l, k);
      var label = h('label', 'll-pack ll-pack--' + k);
      var input = document.createElement('input');
      input.type = 'radio';
      input.name = 'll-pack';
      input.value = k;
      input.checked = state.pack === k;
      input.disabled = !p.avail;
      var body = h('span', 'll-pack__body');
      if (p.tag) body.appendChild(h('span', 'll-pack__tag', p.tag));
      body.appendChild(h('span', 'll-pack__title', p.jars + (p.jars === 1 ? ' jar' : ' jars')));
      body.appendChild(h('span', 'll-pack__price', p.fmt));
      if (k !== 's') body.appendChild(h('span', 'll-pack__per', p.perJar + ' per jar'));
      if (!p.avail) body.appendChild(h('span', 'll-pack__out', 'Out of stock'));
      else if (p.savePct > 0) body.appendChild(h('span', 'll-pack__save', 'Save ' + p.save + ' (' + p.savePct + '%)'));
      label.appendChild(input);
      label.appendChild(body);
      el.packs.appendChild(label);
    });
    if (el.single) el.single.hidden = true;
    renderBuy();
  }

  function fillPlans(p) {
    var plans = plansFor(p);
    el.plan.textContent = '';
    plans.forEach(function (pl) {
      var o = document.createElement('option');
      o.value = String(pl.id);
      o.textContent = pl.label + ' (save ' + pl.pct + '%)';
      el.plan.appendChild(o);
    });
    if (!plans.length) { state.planId = null; return null; }
    var chosen = plans.filter(function (pl) { return pl.label === state.planLabel; })[0];
    if (!chosen && cfg.preferredInterval) {
      chosen = plans.filter(function (pl) { return pl.label.toLowerCase().indexOf(cfg.preferredInterval.toLowerCase()) > -1; })[0];
    }
    chosen = chosen || plans[0];
    el.plan.value = String(chosen.id);
    state.planId = chosen.id;
    state.planLabel = chosen.label;
    return chosen;
  }

  function currentPlan(p) {
    return plansFor(p).filter(function (pl) { return pl.id === state.planId; })[0] || null;
  }

  function writeTerms(plan) {
    el.terms.textContent = '';
    var interval = plan.label.replace(/^every\s+/i, '');
    var text = (cfg.terms || '').replace('{interval}', interval).replace('{price}', plan.per);
    var parts = text.split('{account}');
    el.terms.appendChild(document.createTextNode(parts[0]));
    if (parts.length > 1) {
      var a = h('a', null, cfg.accountLabel || 'your account');
      a.href = cfg.manageUrl || '/account';
      el.terms.appendChild(a);
      el.terms.appendChild(document.createTextNode(parts.slice(1).join('{account}')));
    }
  }

  function renderBuy() {
    var l = cur();
    var ok = ensurePack();
    var p = ok ? pk(l, state.pack) : null;

    // Pack radios reflect state
    $$('input[name="ll-pack"]').forEach(function (i) { i.checked = i.value === state.pack; });

    var plan = null;
    var hasPlans = !!(p && plansFor(p).length);
    if (p) {
      el.oncePrice.textContent = p.fmt;
      if (hasPlans) plan = fillPlans(p);
    }
    el.subInput.disabled = !hasPlans;
    if (!hasPlans && state.type === 'sub') state.type = 'once';
    el.onceInput.checked = state.type === 'once';
    el.subInput.checked = state.type === 'sub';
    if (plan) {
      el.subPct.textContent = '– save ' + plan.pct + '%';
      el.subPrice.textContent = plan.per;
    } else {
      el.subPct.textContent = '';
      el.subPrice.textContent = '';
    }
    el.subPanel.hidden = !(state.type === 'sub' && plan);
    el.subNote.hidden = !(p && !hasPlans);
    if (state.type === 'sub' && plan) writeTerms(plan);

    // Price + labels
    var price = !p ? '' : (state.type === 'sub' && plan ? plan.per : p.fmt);
    var checkoutMode = !drawerMode;
    var verb = checkoutMode ? cfg.ctaCheckout : cfg.ctaCart;
    var packLabel = p ? p.jars + (p.jars === 1 ? ' jar' : ' jars') : '';
    var typeSlug = state.type === 'sub' ? 'subscription' : 'one-time';
    buyBtns.forEach(function (b) {
      b.disabled = !p || state.busy;
      b.textContent = p ? verb + ' – ' + price : 'Sold out';
      b.setAttribute('data-ttp-lotion', l.handle);
      b.setAttribute('data-ttp-pack', p ? String(p.jars) : '');
      b.setAttribute('data-ttp-purchase-type', typeSlug);
    });
    var detail = p ? packLabel + ' · ' + (state.type === 'sub' && plan ? 'every ' + plan.label.replace(/^every\s+/i, '') : cfg.onceLabel.toLowerCase()) : '';
    if (el.sName) el.sName.textContent = l.pitch + ' · ' + l.name;
    if (el.sDetail) el.sDetail.textContent = detail;
    if (el.finalSel) el.finalSel.textContent = p ? l.pitch + ' · ' + packLabel + ' · ' + price : '';
    if (el.live && p) el.live.textContent = l.name + ', ' + packLabel + ', ' + price;
    clearError();
  }

  /* ── Events ────────────────────────────────────────── */
  chipInputs.forEach(function (i) {
    i.addEventListener('change', function () { state.li = parseInt(i.value, 10) || 0; renderLotion(); });
  });
  $$('[data-ll-pick]').forEach(function (b) {
    b.addEventListener('click', function () {
      state.li = parseInt(b.getAttribute('data-ll-pick'), 10) || 0;
      renderLotion();
      var top = $('.ll-hero');
      if (top) top.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
      var chip = chipInputs[state.li];
      if (chip) chip.focus({ preventScroll: true });
    });
  });
  el.packs.addEventListener('change', function (e) {
    if (e.target && e.target.name === 'll-pack') { state.pack = e.target.value; renderBuy(); }
  });
  typeInputs.forEach(function (i) {
    i.addEventListener('change', function () { if (i.checked) { state.type = i.value; renderBuy(); } });
  });
  el.plan.addEventListener('change', function () {
    var p = pk(cur(), state.pack);
    var pl = plansFor(p).filter(function (x) { return String(x.id) === el.plan.value; })[0];
    if (pl) { state.planId = pl.id; state.planLabel = pl.label; }
    renderBuy();
  });
  var topLink = $('[data-ll-top]');
  if (topLink) topLink.addEventListener('click', function (e) {
    e.preventDefault();
    var top = $('.ll-hero');
    if (top) top.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
    if (chipInputs[state.li]) chipInputs[state.li].focus({ preventScroll: true });
  });

  /* ── Errors ────────────────────────────────────────── */
  function showError(msg) {
    errBoxes.forEach(function (b) { b.textContent = msg; b.hidden = false; });
  }
  function clearError() {
    errBoxes.forEach(function (b) { b.textContent = ''; b.hidden = true; });
  }

  /* ── Add to cart ───────────────────────────────────── */
  function setBusy(on) {
    state.busy = on;
    buyBtns.forEach(function (b) { b.classList.toggle('is-busy', on); b.disabled = on || b.textContent === 'Sold out'; });
  }

  function fail(err) {
    setBusy(false);
    var desc = err && (err.description || err.message);
    var stock = /sold out|stock|available|inventory/i.test(desc || '');
    if (stock) {
      var p = pk(cur(), state.pack);
      if (p) p.avail = false;
      renderLotion();
    }
    showError(stock || !desc ? (stock ? cfg.soldout : cfg.errorGeneric) : desc);
  }

  function buy() {
    if (state.busy) return;
    var l = cur();
    var p = pk(l, state.pack);
    if (!p || !p.avail) { showError(cfg.soldout); return; }
    var plan = state.type === 'sub' ? currentPlan(p) : null;
    clearError();
    setBusy(true);

    var cartEl = drawerMode ? document.querySelector('cart-drawer') : null;
    var req;
    if (cartEl && typeof cartEl.getSectionsToRender === 'function') {
      // Theme-native drawer path (mirrors product-form.js)
      var fd = new FormData();
      fd.append('id', p.vid);
      fd.append('quantity', 1);
      if (plan) fd.append('selling_plan', plan.id);
      fd.append('sections', cartEl.getSectionsToRender().map(function (s) { return s.id; }));
      fd.append('sections_url', window.location.pathname);
      req = fetch(cfg.cartAdd, { method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/javascript' }, body: fd });
    } else {
      var item = { id: p.vid, quantity: 1 };
      if (plan) item.selling_plan = plan.id;
      req = fetch(cfg.cartAddJs, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [item] }) });
    }

    req.then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok || res.j.status) throw res.j;
        if (drawerMode && window.ttpOpenCart) {
          setBusy(false);
          if (window.publish && window.PUB_SUB_EVENTS) window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'ttp-lander', productVariantId: p.vid });
          window.ttpOpenCart([]);
        } else if (cartEl && typeof cartEl.renderContents === 'function' && drawerMode) {
          setBusy(false);
          if (window.publish && window.PUB_SUB_EVENTS) window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'ttp-lotion-lander', productVariantId: p.vid });
          cartEl.renderContents(res.j);
        } else if (drawerMode) {
          window.location.href = cfg.cartUrl;
        } else {
          // Carry utm_* / fbclid through to checkout
          window.location.href = cfg.checkout + (window.location.search || '');
        }
      })
      .catch(fail);
  }
  buyBtns.forEach(function (b) { b.addEventListener('click', buy); });

  /* ── Sticky buy bar: show once the main CTA has scrolled past; hide at final CTA ── */
  if (el.sticky && 'IntersectionObserver' in window && el.mainCta) {
    var mainVisible = true, past = false, finalVisible = false;
    var setSticky = function () {
      var on = !mainVisible && past && !finalVisible;
      el.sticky.classList.toggle('is-on', on);
      el.sticky.setAttribute('aria-hidden', on ? 'false' : 'true');
      if (on) el.sticky.removeAttribute('inert'); else el.sticky.setAttribute('inert', '');
    };
    new IntersectionObserver(function (entries) {
      var e = entries[entries.length - 1];
      mainVisible = e.isIntersecting;
      past = e.boundingClientRect.top < 0;
      setSticky();
    }).observe(el.mainCta);
    if (el.final) {
      new IntersectionObserver(function (entries) {
        finalVisible = entries[entries.length - 1].isIntersecting;
        setSticky();
      }).observe(el.final);
    }
  }

  /* ── Preload the other lotions' images so swaps are instant ── */
  function preload() {
    lotions.forEach(function (l, i) {
      if (i === state.li || !l.img) return;
      var im = new Image();
      if (el.img) im.sizes = el.img.sizes;
      im.srcset = l.img.srcset;
      im.src = l.img.src;
    });
  }
  if ('requestIdleCallback' in window) window.requestIdleCallback(preload, { timeout: 2500 });
  else window.setTimeout(preload, 1200);

  renderLotion();
})();
